import { TabPanel } from '@mui/lab';
import {
  AccordionDetails,
  AccordionSummary,
  Box,
  styled,
  Tab,
  Tabs,
} from '@mui/material';

export const AnimationAccordionSummary = styled(AccordionSummary)(() => ({
  padding: '0 20px',
  borderBottom: `1px solid #000`,
}));

export const AnimationAccordionDetails = styled(AccordionDetails)({
  padding: 0,
});

export const AnimationTypeTabs = styled(Tabs)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.light}`,
  borderRadius: '5px',
  margin: '10px 0',
}));

export const AlertContainer = styled(Box)`
  padding-bottom: 10px;
`;

export const AnimationTypeTab = styled(Tab)(({ theme, $showBorder }) => ({
  '&.Mui-selected': {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
  },
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.common.white,
  borderLeft: $showBorder ? `1px solid ${theme.palette.primary.light}` : 'none',
  borderRight: $showBorder
    ? `1px solid ${theme.palette.primary.light}`
    : 'none',
  textTransform: 'none',
}));

export const StyledTabPanel = styled(TabPanel)`
  padding: 0px;
`;
